import React, { useCallback, useEffect, useState } from "react"

interface SearchIconProps {
  defaultStrokeColor: string
  activeStrokeColor: string
  isSelected: boolean
  onHoverStrokeColor: string
}

const SearchIcon: React.FC<SearchIconProps> = ({
  defaultStrokeColor,
  activeStrokeColor,
  onHoverStrokeColor,
  isSelected,
}) => {
  const [strokeColor, setStrokeColor] = useState(defaultStrokeColor)

  const handleMouseEnter = useCallback(() => {
    !isSelected && setStrokeColor(onHoverStrokeColor)
  }, [isSelected, onHoverStrokeColor])

  const handleMouseLeave = useCallback(() => {
    !isSelected && setStrokeColor(defaultStrokeColor)
  }, [isSelected, defaultStrokeColor])

  useEffect(() => {
    isSelected
      ? setStrokeColor(activeStrokeColor)
      : setStrokeColor(defaultStrokeColor)
  }, [isSelected, activeStrokeColor, defaultStrokeColor])

  return (
    <svg
      width="25"
      height="37"
      viewBox="0 0 25 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <rect x="0.5" width="24" height="37" fill="white" />
      <path
        d="M21.5 27.5L15.5 21.5M3.5 16.5C3.5 17.4193 3.68106 18.3295 4.03284 19.1788C4.38463 20.0281 4.90024 20.7997 5.55025 21.4497C6.20026 22.0998 6.97194 22.6154 7.82122 22.9672C8.6705 23.3189 9.58075 23.5 10.5 23.5C11.4193 23.5 12.3295 23.3189 13.1788 22.9672C14.0281 22.6154 14.7997 22.0998 15.4497 21.4497C16.0998 20.7997 16.6154 20.0281 16.9672 19.1788C17.3189 18.3295 17.5 17.4193 17.5 16.5C17.5 15.5807 17.3189 14.6705 16.9672 13.8212C16.6154 12.9719 16.0998 12.2003 15.4497 11.5503C14.7997 10.9002 14.0281 10.3846 13.1788 10.0328C12.3295 9.68106 11.4193 9.5 10.5 9.5C9.58075 9.5 8.6705 9.68106 7.82122 10.0328C6.97194 10.3846 6.20026 10.9002 5.55025 11.5503C4.90024 12.2003 4.38463 12.9719 4.03284 13.8212C3.68106 14.6705 3.5 15.5807 3.5 16.5Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SearchIcon
